import React, { ReactNode } from 'react'
import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit'
import {
  Provider,
  useSelector,
  useDispatch,
  TypedUseSelectorHook
} from 'react-redux'

import { adminSlice } from './slices/admin.slice'
import { adminApi } from './apis/admin.api'

const { increment, clear } = adminSlice.actions

export const store = configureStore({
  reducer: {
    admin: adminSlice.reducer,
    [adminApi.reducerPath]: adminApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      adminApi.middleware
    )
})

export function useStore() {
  const dispatch = useDispatch()
  const count = useSelector((state) => state)
  // eslint-disable-next-line
  // @ts-ignore
  const allowedDomains = useSelector((state) => state.admin.allowedDomains)

  return {
    count,
    allowedDomains,
    increment: () => dispatch(increment()),
    clear: () => dispatch(clear())
  }
}

export const useAppDispatch = () => useDispatch()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
/* eslint-disable */
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
type IStoreProviderProps = { children: ReactNode }
export function StoreProvider({ children }: IStoreProviderProps) {
  return <Provider store={store}> {children}</Provider>
}

export default StoreProvider
